'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _TooltipIcon = require('./TooltipIcon');

var _TooltipIcon2 = _interopRequireDefault(_TooltipIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-unused-expressions: 0 */
var Tooltip = function Tooltip(props) {
  var className = props.className,
      display = props.display,
      id = props.id,
      position = props.position,
      hoverText = props.hoverText,
      tooltipText = props.tooltipText,
      multiline = props.multiline;

  var underline = display === 'underline' ? 'pxl-tooltip-underline' : '';
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'span',
      { className: 'pxl-tooltip ' + underline + ' ' + className, 'data-tip': hoverText, 'data-for': id },
      tooltipText,
      _react2.default.createElement(_TooltipIcon2.default, { display: display })
    ),
    _react2.default.createElement(_reactTooltip2.default, { id: id, place: position, multiline: multiline })
  );
};

Tooltip.propTypes = {
  className: _propTypes2.default.string,
  display: _propTypes2.default.oneOf(['underline', 'icon']),
  hoverText: _propTypes2.default.string.isRequired,
  id: _propTypes2.default.string.isRequired,
  multiline: _propTypes2.default.bool,
  position: _propTypes2.default.oneOf(['left', 'top', 'bottom', 'right']),
  tooltipText: _propTypes2.default.string.isRequired
};

Tooltip.defaultProps = {
  className: '',
  display: 'icon',
  multiline: false,
  position: 'top'
};

exports.default = Tooltip;